import { SvelteMap } from 'svelte/reactivity'
import type { NotificationPayload } from './types'

export type Notification = {
  id: string | number
  message: string
  payload: NotificationPayload
}

export const notifications = new SvelteMap<
  string | number,
  null | (Notification & { onDismiss: () => void })
>()

export type NotificationOptions = {
  onDismiss?: () => void
  /** If not provided, the notification will remain visible until dismissed. */
  duration?: number
}

export const showSystemNotification = (
  message: string,
  title?: string,
  options?: NotificationOptions,
) => {
  showNotification(
    {
      id: message,
      message,
      payload: {
        type: 'generic',
        title: title || 'System message',
        description: message,
      },
    },
    options ?? {},
  )
}

export const showNotification = (
  notification: Notification,
  options: NotificationOptions = {},
) => {
  if (notifications.keys().some((key) => key === notification.id)) return

  let timeoutId: number | undefined

  const onDismiss = () => {
    if (timeoutId) {
      window.clearTimeout(timeoutId)
    }
    removeNotification(notification.id)
    options.onDismiss?.()
  }

  notifications.set(notification.id, { ...notification, onDismiss })

  if (options.duration) {
    timeoutId = window.setTimeout(() => {
      onDismiss()
    }, options.duration)
  }
}

const removeNotification = (id: string | number) => {
  if (!notifications.has(id)) return
  notifications.set(id, null)
}
